import { useState } from "react";
import {
  UsersApi,
  RequestGetUserSearchOptionsRequest,
  ResponseUserSearchOptionsResponse,
  UsersSearchOptionsPostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetUsersSearchOptions = () => {
  const [userSearchOptions, setUserSearchOptions] = useState<
    ResponseUserSearchOptionsResponse[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchUserSearchOptions = async (
    requestParams: RequestGetUserSearchOptionsRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: UsersSearchOptionsPostRequest = {
        req: requestParams,
      };

      const api = new UsersApi(config);
      const response = await api.usersSearchOptionsPost(request);
      setUserSearchOptions(response);
      return response;
    } catch (err) {
      setError("ユーザー検索バーの取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { userSearchOptions, fetchUserSearchOptions, error, isLoading };
};
